import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton'
import {GridList, GridTile} from 'material-ui/GridList';

import { firebase, storage } from './firebase';
import firebaseui from 'firebaseui';

import checkmark from "./ic_check_circle_green_48dp_2x.png"

class FirebaseAuthContainer extends Component {
  componentDidMount() {

    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        if (user.displayName) {
          firebase.database()
            .ref(user.uid)
            .child("displayName")
            .set(user.displayName);
        }
        if (user.email) {
          firebase.database()
            .ref(user.uid)
            .child("email")
            .set(user.email);
        }

        document.getElementById('sign-in-status').textContent = 'Signed in as ' + user.email;
      } else {

        document.getElementById('sign-in-status').textContent = 'First, sign in:';
        // FirebaseUI config.
        var uiConfig = {
          signInSuccessUrl: '/nuq',
          signInOptions: [
            // Leave the lines as is for the providers you want to offer your users.
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
            // firebase.auth.GithubAuthProvider.PROVIDER_ID,
            // firebase.auth.EmailAuthProvider.PROVIDER_ID
          ],
          // Terms of service url.
          tosUrl: '<your-tos-url>'
        };

        // Initialize the FirebaseUI Widget using Firebase.
        var ui = new firebaseui.auth.AuthUI(firebase.auth());
        // The start method will wait until the DOM is loaded.
        ui.start('#firebaseui-auth-container', uiConfig);
      }
    }, function(error) {
      console.log(error);
    });
  }

  render() {
    return (
      <div>
        <div id="sign-in-status"></div>
        <div id="firebaseui-auth-container"></div>
      </div>
    )
  }
}


var thumbnailsRef = storage.ref().child("nuq-artwork").child("thumbnails");


function finish() {
  window.location = '/nuq-finished'
}

class FirebaseImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      storageRef: props.storageRef,
      url: "#",
      selected: false
    }
  }

  componentWillUpdate(nextProps, nextState) {

  }


  updateWithURL(user) {
    if (!user) {
      return;
    }

    console.log("componentWillUpdate with user " + user);

    if (user == null) {
      return;
    }

    var imageId = this.state.storageRef.name.replace('.jpg', '');
    this.firebaseRef = firebase.database().ref()
      .child(user.uid).child('nuq').child(imageId);

    this.firebaseRef.on('value', function(snapshot) {
      this.setState({selected: snapshot.val()});
    }.bind(this));

    this.state.storageRef.getDownloadURL().then(
      (url) => this.setState({ url: url })
    ).catch((error) => {
      console.log(error);
      console.log(error.code);
      switch (error.code) {
        case 'storage/object_not_found':
          // File doesn't exist
          break;

        case 'storage/unauthorized':
          // User doesn't have permission to access the object
          break;

        case 'storage/canceled':
          // User canceled the upload
          break;

        case 'storage/unknown':
          // Unknown error occurred, inspect the server response
          break;

        default:
          break;
      }
    });
  }

  toggleSelected(e) {
    this.firebaseRef.set(!this.state.selected);
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(
      (user) => this.updateWithURL(user)
    );
  }

  componentWillUnmount() {
    if (this.ref != null) {
      this.ref.off();
    }
  }


  render() {
    return (
      <div style={{position: "relative"}}>
        <div style={{width: "100%"}}>
          <img
            style={{width: "inherit"}}
            onClick={this.toggleSelected.bind(this)}
            src={this.state.url}
            alt="artwork example"></img>
        </div>
        <div hidden={!this.state.selected}
          style={{position: "absolute", right: "10px", top: "10px"}}>
          <img src={checkmark}
            width={48}
            height={48}
            onClick={this.toggleSelected.bind(this)}
            alt="checkmark"
             />
        </div>
      </div>
    )
  }
}

class ArtworkTastePage extends Component {
  constructor(props) {
    super(props);

    this.pageLength = 12;
    this.finished = false;
  }

  componentWillMount() {
    this.setState({
      images: []
    });

    this.loadMore();
  }

  updateState(dataSnapshot) {
    var newData = [];
    dataSnapshot.forEach(function(childSnapshot) {
      newData.push({
        id: childSnapshot.key,
        value: childSnapshot.val()
      });
    });

    if (newData.length > this.pageLength) {
      this.extraItem = newData.pop();
    } else {
      this.finished = true;
    }

    this.setState(
      (prevState, props) => ({
        images: prevState.images.concat(newData)
      })
    );
  }

  loadMore() {
    if (this.finished) {
      return;
    }

    this.firebaseRef = firebase.database().ref('nuq').orderByKey()
      .limitToFirst(this.pageLength+1);
    if (this.extraItem != null) {
      this.firebaseRef = this.firebaseRef.startAt(this.extraItem.id);
    }

    this.firebaseRef.once('value')
      .then((dataSnapshot) => this.updateState(dataSnapshot));
  }

  render() {
    return (
      <div className="ArtworkTastePage"
           style={{width: '80%', margin: 'auto', textAlign: "center"}}>

        <h1>Teach us your tastes</h1>
        <FirebaseAuthContainer />
        <p>Next, tap on artwork you like</p>
        <GridList className="artwork-grid">
          {this.state.images.map((image) =>
            <GridTile key={image.id}
              col={4}
              align="middle">
              <FirebaseImage storageRef={thumbnailsRef.child(image.value + '.jpg')} />
            </GridTile>
          )}
        </GridList>
        <div>
          <RaisedButton onClick={this.loadMore.bind(this)}>Load More Artwork</RaisedButton>
        </div>
        <div>
          <RaisedButton primary={true} onClick={finish}>Finished</RaisedButton>
        </div>
      </div>
    );
  }
}

export default ArtworkTastePage;



// WEBPACK FOOTER //
// ./src/ArtworkTastePage.js